import React from "react";
import PropTypes from "prop-types";
import { View } from "@react-pdf/renderer";

import { rangeStyles } from "./demographic.styles";

const MetricRange = ({ value, maxValue }) => {
  return (
    <View className={rangeStyles.container}>
      <View
        style={[rangeStyles.threshold, { left: `${(100 / maxValue) * 100}%` }]}
      />
      <View
        style={[
          rangeStyles.bar,
          { width: `${(value / maxValue) * 100}%` },
          value < 100 && rangeStyles.barPale
        ]}
      />
    </View>
  );
};

MetricRange.propTypes = {
  value: PropTypes.number.isRequired,
  maxValue: PropTypes.number.isRequired
};

export default MetricRange;
